export const getConfig=()=>{
    return {
        cdn: "https://stdstprd.blob.core.windows.net/ifc-cloud-viewer-public-models",
    }
}